import { UseFormReturn } from 'react-hook-form'

import { TransactionOverview } from '../components/TransactionOverview'
import { MigrateDialogTxOverview } from '../types'
import { TokenWithBalance } from '@/domain/common/types'
import { Token } from '@/domain/types/Token'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { FormAndOverviewWrapper } from '@/features/dialogs/common/components/FormAndOverviewWrapper'
import { DialogForm } from '@/features/dialogs/common/components/form/DialogForm'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'
import { FormFieldsForDialog } from '@/features/dialogs/common/types'
import { assets } from '@/ui/assets'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { ExternalLink } from '@/ui/atoms/link/Link'
import { links } from '@/ui/constants/links'
import { Info } from '@/ui/molecules/info/Info'

interface UpgradeSdaiViewProps {
  sdai: Token
  susds: Token
  actionsViewState: ActionsViewState
  form: UseFormReturn<AssetInputSchema>
  assetsFields: FormFieldsForDialog
  selectableAssets: TokenWithBalance[]
  txOverview: MigrateDialogTxOverview
}

export function UpgradeSdaiView({
  sdai,
  susds,
  actionsViewState,
  form,
  assetsFields,
  selectableAssets,
  txOverview,
}: UpgradeSdaiViewProps) {
  return (
    <div>
      <img
        src={assets.savings.sdaiUpgrade}
        width={686}
        height={207}
        alt="sdai-to-susds-upgrade"
        className="w-full bg-cover bg-sdai-upgrade bg-no-repeat"
      />
      <MultiPanelDialog className="p-8">
        <DialogTitle className="flex items-center gap-2">
          Upgrade {sdai.symbol} to {susds.symbol}{' '}
          <Info>
            <div className="flex flex-col gap-2">
              <p>
                {susds.symbol} is the new version of {sdai.symbol}.
              </p>
              <p>
                Upgrading to {susds.symbol} unlocks additional benefits, providing you with more opportunities to earn
                rewards within the ecosystem.
              </p>
              <p>Upgrade is optional and you can continue using {sdai.symbol} if you prefer.</p>
              <ExternalLink to={links.docs.savings.upgradeSdai}>Learn more</ExternalLink>
            </div>
          </Info>
        </DialogTitle>

        <FormAndOverviewWrapper>
          <DialogForm form={form} assetsFields={assetsFields} selectorAssets={selectableAssets} />
          <TransactionOverview txOverview={txOverview} selectedToken={assetsFields.selectedAsset} />
        </FormAndOverviewWrapper>

        <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
      </MultiPanelDialog>
    </div>
  )
}
